export const noGradeReasonEnum = [
  'duration_too_short',
  'llm_failure',
  'no_video_on_s3',
  'retry_exhausted',
] as const
export type NoGradeReason = (typeof noGradeReasonEnum)[number]

export const noGradeReasonLabels: Record<NoGradeReason, string> = {
  duration_too_short: 'Interaction trop courte',
  llm_failure: 'Échec analyse IA',
  no_video_on_s3: 'Vidéo absente ou vide',
  retry_exhausted: 'Tentatives de traitement épuisées',
}
